import { Router } from '@angular/router';
import { NotificationSlugEnum } from '@app/generated/graphql';
import { INotificationConfig } from '../interfaces/interface';
import { DEFAULT_MESSAGE_LIFE } from './notification.constants';

export function createOfferNotificationConfig(
  router: Router,
): INotificationConfig {
  return {
    slug: NotificationSlugEnum.Offer,
    preference: {
      displayTitle:
        'Updates on buyer interactions with offers I have sent out or engaged with',
      displayDescription:
        'Get notified on new offers, counter offers, offer acceptances and negotiations that have been ended.',
      defaultConfig: {},
    },
    message: {
      iconPath: '/assets/icons/general/info.svg',
      actionLabel: 'View',
      resolveDisplayTitle: (
        metadata: Record<string, unknown>,
      ): string | undefined => {
        const action = metadata['action'] as string | undefined;

        switch (action) {
          case 'rejected':
            return 'Negotiations ended';
          case 'accepted':
            return 'Your offer has been accepted';
          default:
            return 'Counter offer on your supply';
        }
      },
      resolveDisplayDescription: (
        metadata: Record<string, unknown>,
      ): string | undefined => {
        const buyerName = metadata['buyer_name'] as string | undefined;
        const offerTitle = metadata['offer_title'] as string | undefined;
        const action = metadata['action'] as string | undefined;

        switch (action) {
          case 'rejected':
            return `${buyerName} is no longer interested in ${offerTitle}. The negotiation has been ended.`;
          case 'accepted':
            return `${buyerName} accepted your offer on ${offerTitle}. An order has been created.`;
          default:
            return `${buyerName} has counter offered on ${offerTitle}.`;
        }
      },
      action: (metadata: Record<string, unknown>) => {
        const action = metadata['action'] as string | undefined;
        const orderId = metadata['order_id'] as string | undefined;
        const offerId = metadata['offer_id'] as string | undefined;

        if (!action) {
          return;
        }

        switch (action) {
          case 'rejected':
            if (!offerId) {
              return;
            }

            router.navigate(['/account/offers/counter-offers'], {
              queryParams: { viewOfferId: offerId },
            });
            break;
          case 'accepted':
            if (!orderId) {
              return;
            }

            router.navigate(['/account/order', orderId]);
            break;
          default:
            if (!offerId) {
              return;
            }

            router.navigate(['/account/offers/counter-offers'], {
              queryParams: { viewOfferId: offerId },
            });
            break;
        }
      },
      life: DEFAULT_MESSAGE_LIFE,
    },
  };
}
